import { FC } from 'react';
import { SvgIconProps } from '@mui/material';

import * as icons from './components';

type IconKey = keyof typeof icons;

export const Icon: Record<IconKey, FC<SvgIconProps>> = icons;
